export const w = window.innerWidth;
export const w_2 = w / 2;
export const h = window.innerHeight;
export const h_2 = h / 2;
export const min = w <= h ? w : h; // Minimun size
export const max = w >= h ? w : h; // Max size
